import { useEffect, useMemo, useState } from 'react'
import { getMe, getToken, setToken } from './api.js'
import { AuthContext } from './auth-context.js'

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(Boolean(getToken()))

  useEffect(() => {
    const handleExpired = () => {
      setUser(null)
      setLoading(false)
    }
    window.addEventListener('auth:expired', handleExpired)
    return () => window.removeEventListener('auth:expired', handleExpired)
  }, [])

  useEffect(() => {
    const controller = new AbortController()
    if (!getToken()) {
      setLoading(false)
      return () => controller.abort()
    }

    getMe(controller.signal)
      .then(({ user: currentUser }) => setUser(currentUser))
      .catch(() => {
        setToken('')
        setUser(null)
      })
      .finally(() => setLoading(false))

    return () => controller.abort()
  }, [])

  const value = useMemo(() => ({
    user,
    loading,
    isLoggedIn: Boolean(user),
    async refreshUser() {
      if (!getToken()) return null
      const { user: currentUser } = await getMe()
      setUser(currentUser)
      return currentUser
    },
    completeLogin(data) {
      setToken(data.token)
      setUser(data.user)
    },
    logout() {
      setToken('')
      setUser(null)
    },
  }), [loading, user])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
